import script from "./FileTreeNode.vue?vue&type=script&setup=true&lang=js"
export * from "./FileTreeNode.vue?vue&type=script&setup=true&lang=js"

import "./FileTreeNode.vue?vue&type=style&index=0&id=789d9074&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-789d9074"]])

export default __exports__